<template>
  <div
    :class="$style.nameText"
  >
    <div
      data-test-id="CommandTemplateName__NameText"
    >
      {{ templateNameText }}
    </div>
    <div
      :class="$style.subtitleStyle"
      data-test-id="CommandTemplateName__NameSubText"
    >
      {{ templateNameSubtext }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'CommandTemplateName',

  props: {
    item: {
      default: () => ({}),
      type: Object,
    },
  },

  computed: {
    templateNameSubtext() {
      const { source } = this.item;
      return source !== 'Custom' ? `Source: ${source}` : '';
    },

    templateNameText() {
      const { name } = this.item;
      const origination = name.split('|');
      const templateName = origination[0];
      return templateName;
    },
  },
};
</script>
<style module>
.nameText {
  max-width: 200px;
}

.subtitleStyle {
  font-style: italic;
}
</style>
